import Api from "./Api";

const endpoint = "/anwesenheitsverwaltung";
export default {
    get(proben_id, voice, params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(
            endpoint + "/" + proben_id + "/" + voice,
            usedParams
        );
    },
    get_new(werk_id, voice, params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(
            endpoint + "_neu/werk/" + werk_id + "/stimme/" + voice,
            usedParams
        );
    },
    getExcluded(werk_id, voice, params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(
            endpoint +
                "_neu/werk/" +
                werk_id +
                "/stimme/" +
                voice +
                "/excluded",
            usedParams
        );
    },
    print(werk_id, voice) {
        return Api.fetchData(
            endpoint + "_neu/werk/" + werk_id + "/stimme/" + voice + "/print"
        );
    },
    freikarten(werk_id, voice) {
        return Api.fetchData(
            endpoint +
                "_neu/werk/" +
                werk_id +
                "/stimme/" +
                voice +
                "/freikarten"
        );
    },
    getEvaluation() {
        return Api.fetchData(endpoint + "_neu/evaluation");
    },
    getAnwesenheitMitglied(mitglied_id) {
        return Api.fetchData(endpoint + "_neu/mitglied/" + mitglied_id);
    },
    put(termin_id, mitglied_id) {
        return Api.putData(
            endpoint + "_neu/termin/" + termin_id + "/mitglied/" + mitglied_id
        );
    },
    putAll(termin_id, voice) {
        return Api.putData(
            endpoint + "_neu/termin/" + termin_id + "/stimme/" + voice
        );
    },
    delete(termin_id, mitglied_id) {
        return Api.deleteData(
            endpoint + "_neu/termin/" + termin_id + "/mitglied/" + mitglied_id
        );
    },
    deleteAll(termin_id, voice) {
        return Api.deleteData(
            endpoint + "_neu/termin/" + termin_id + "/stimme/" + voice
        );
    },
    getNearestTermin(werk_id, voice) {
        return Api.fetchData(
            endpoint + "_neu/termin/" + werk_id + "/nearest/" + voice
        );
    }
};
